import React from 'react'
import { Button } from '../components'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import { classNames } from '../utils'
interface FooterCtaProps {
  title: string
  text?: string
  ctaPath: string
  ctaText: string
  ctaNewWindow?: boolean
  backgroundImage: IGatsbyImageData
  backgroundImageAltText: string
  customStyle?: {}
  customClasses?: string
}

export function FooterCta({
  customClasses,
  title,
  text,
  ctaPath,
  ctaText,
  ctaNewWindow,
  backgroundImage,
  backgroundImageAltText,
  customStyle,
}: FooterCtaProps) {
  return (
    <section
      className={classNames('relative z-10 py-4 sm:py-24', customClasses)}
      style={customStyle}
    >
      <div className="container mx-auto px-8 text-center">
        <div className="absolute inset-0 -z-10 overflow-hidden">
          <GatsbyImage
            alt={backgroundImageAltText}
            image={backgroundImage}
            objectFit="cover"
            class="h-full w-full"
          />
        </div>
        <h2 className="mb-7 text-xl font-bold text-default-lighter sm:text-3xl">
          {title}
        </h2>
        {text && <p className="mb-11 text-lg text-default-lighter">{text}</p>}
        <Button
          size="xl"
          icon="paper-plane"
          variant="primary"
          target={ctaNewWindow ? '_blank' : '_self'}
          to={ctaPath}
        >
          {ctaText}
        </Button>
      </div>
    </section>
  )
}
